import HTMLClass from "./HTMLClass";

export default class DivStatuses
{
    constructor($container) 
    {
        this.$element = $container;
        this._loader;
    }

    showLoader(message) {
        const el = document.createElement('span');
        HTMLClass.addClass(el, 'sellyCS__loader');
        el.innerHTML = message;
        this.$element.append(el);
        this._loader = el;
    }

    hideLoader() 
    {
        this._loader.parentNode.removeChild(this._loader);
    }

    message(text, type = 'success') 
    {
        const el = document.createElement('p');
        HTMLClass.addClass(el, 'sellyCS__form__message');
        HTMLClass.addClass(el, `sellyCS__form__message--${type}`);
        el.innerHTML = text;
        this.$element.append(el);
        //const delay = type == 'error' ? 6000 : 2000;
        if (type != 'error') {
            setTimeout(() => {
                el.parentNode.removeChild(el);
            }, 2000);
        }
        
    }

    hideMessages()
    {
        const $messages = this.$element.querySelectorAll('.sellyCS__form__message');
        $messages.forEach(item => {
            item.parentNode.removeChild(item);
        });
    }
}